<div class="col-sm-12">

    <h3 class="text-light-blue">
        Meses relacionados ao filtro de <b>{{ this.periodoInicial | date:'dd/MM/yyyy' }}</b> até <b>{{ this.periodoFinal
            | date:'dd/MM/yyyy' }}</b>

        <button class="btn btn-sm btn-danger pull-right" (click)="generateReport()"><i
                class="fa fa-fw fa-file-pdf-o"></i> Gerar relatório</button>
    </h3>

    <hr>

    <table class="table table-striped">
        <tbody>
            <tr>
                <th>Conta</th>
                <th class="text-center">Tipo</th>
                <th>Descrição</th>
                <th class="text-center">Valor da transação</th>
                <th class="text-center">Data da transação</th>
            </tr>
            <tr *ngFor="let obj of listaExtrato">
                <td>{{obj.contaBancaria.descricao}}</td>
                <td class="text-center">
                    <ng-container *ngIf="obj.tipoDespesaReceita.tipo === 'Receita' ">
                        <b style="color: #00a65a">{{obj.tipoDespesaReceita.tipo}}</b>
                    </ng-container>
                    <ng-container *ngIf="obj.tipoDespesaReceita.tipo === 'Despesa' ">
                        <b style="color: #ff5d5d">{{obj.tipoDespesaReceita.tipo}}</b>
                    </ng-container>
                </td>
                <td>{{obj.infoextrato}}</td>
                <td class="text-center">
                    <ng-container *ngIf="obj.tipoDespesaReceita.tipo === 'Receita' ">
                        <b style="color: #00a65a">{{obj.valorOp | currency:'BRL':'symbol-narrow':'1.2-2'}}</b>
                    </ng-container>
                    <ng-container *ngIf="obj.tipoDespesaReceita.tipo === 'Despesa' ">
                        <b style="color: #ff5d5d">{{obj.valorOp | currency:'BRL':'symbol-narrow':'1.2-2'}}</b>
                    </ng-container>
                </td>
               <td class="text-center">{{obj.dataFatoMovimentacao | date:'dd/MM/yyyy'}}</td>
            </tr>
        </tbody>
    </table>

    <div class="row" style="margin-top: 10px;">
        <div class="col-sm-5 col-sm-offset-7">
            <table class="table table-bordered" style="margin-bottom: 0;">
                <tbody>
                    <tr>
                        <td><b>Somatório total das receitas</b></td>
                        <td class="text-right"><b style="color: #00a65a">{{ totalReceitas | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></td>
                    </tr>
                    <tr>
                        <td><b>Somatório total das despesas</b></td>
                        <td class="text-right"><b style="color: #ff5d5d">{{ totalDespesas | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></td>
                    </tr>
                    <tr style="background-color: #f4f4f4;">
                        <td><b>Saldo final apurado (Receitas - Despesas)</b></td>
                        <td class="text-right"><b [style.color]="saldoFinal < 0 ? '#ff5d5d' : '#00a65a'">{{ saldoFinal | currency:'BRL':'symbol-narrow':'1.2-2' }}</b></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>